"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAccordionItemWrap = exports.FdrAccordionIcon = exports.DefaultFdrAccordionButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
exports.DefaultFdrAccordionButton = (0, styled_components_1.default)(core_basis_bs_button_1.BsButton)((0, util_theme_sxc_1.sx2CssThemeFn)({
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'lightGreyFirst',
    mb: '-1px',
    transition: 'none',
}));
exports.FdrAccordionIcon = (0, styled_components_1.default)(core_basis_bs_icon_1.BsIcon)(({ active }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    transform: `${active ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
    transition: 'fast',
    height: '12px',
    ml: 1,
}));
exports.FdrAccordionItemWrap = styled_components_1.default.div(({ theme: { space } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    flexDirection: 'column',
    '.accordionButtonWrap': {
        p: `0 ${space[3]}`,
    },
    '.accordionContent': {
        display: 'none',
    },
    '.accordionContent.scrollable': {
        overflow: 'auto',
    },
    '.accordionContent.active': {
        display: 'block',
    },
}));
//# sourceMappingURL=fdr-accordion.styles.js.map